import { INSURANCE_BY_KM_ENTITY_CODE } from "./constants";

export const isInsuranceByKm = ({ mainAttribute }): boolean =>
  mainAttribute ? mainAttribute.entity.code === INSURANCE_BY_KM_ENTITY_CODE : false;
